import React from 'react';
import { CardValideNG } from '../Cards';

const PageEcourrierOk = () => (
    <CardValideNG Lien="/">
        <p>Vos choix de courriers électroniques sont définitivement validés. 
        Cliquez sur OK pour vous reconnecter à votre espace Gérer-Ma-Copro.</p>
    </CardValideNG>
);

export default PageEcourrierOk;


// WEBPACK FOOTER //
// ./src/components/Adherent/Ecourrier/PageEcourrierOk.js